import { EJackpotType, EWinType } from '@Managers/Redux/HttpState/HttpState.types';
import { EWinPresentationStates } from './States/WinPresentationStates';
import { EWaitFor, IWinPresentationStepsConfig } from './WinPresentation.types';

export const WIN_PRESENTATION_ANIMATION_STATES = new Set<EWinPresentationStates>([
    EWinPresentationStates.WIN_PRESENTATION_IN_STATE,
    EWinPresentationStates.WIN_PRESENTATION_IDLE_STATE,
    EWinPresentationStates.WIN_PRESENTATION_OUT_STATE
]);

export const WIN_PRESENTATION_STEPS_CONFIG: IWinPresentationStepsConfig = {
    [EWinPresentationStates.WIN_PRESENTATION_HIDDEN_STATE]: {
        waitFor: EWaitFor.WIN_PRESENTATION_START,
        skippable: false
    },
    [EWinPresentationStates.PRE_WIN_PRESENTATION_STATE]: {
        waitFor: EWaitFor.NONE,
        skippable: false
    },
    [EWinPresentationStates.WIN_PRESENTATION_HOLD_STATE]: {
        waitFor: EWaitFor.TIMER,
        skippable: true,

        stopSkipping: true,
        timer: true,
        particleEmitter: { stop: true }
    },
    [EWinPresentationStates.POST_WIN_PRESENTATION_STATE]: {
        waitFor: EWaitFor.NONE,
        skippable: false,
        stopSkipping: true
    },
    sublevels: {
        [EWinType.NORMAL_WIN]: {
            [EWinPresentationStates.WIN_PRESENTATION_IN_STATE]: {
                waitFor: EWaitFor.ANIMATION,
                skippable: true,

                odometer: { tween: true, font: true }
            },
            [EWinPresentationStates.WIN_PRESENTATION_IDLE_STATE]: {
                waitFor: EWaitFor.ODOMETER,
                skippable: true
            },
            [EWinPresentationStates.WIN_PRESENTATION_OUT_STATE]: {
                waitFor: EWaitFor.ANIMATION,
                skippable: true
            }
        },
        [EWinType.BIG_WIN]: {
            [EWinPresentationStates.WIN_PRESENTATION_IN_STATE]: {
                waitFor: EWaitFor.ANIMATION,
                skippable: true,

                odometer: { font: true },
                particleEmitter: { start: true }
            },
            [EWinPresentationStates.WIN_PRESENTATION_IDLE_STATE]: {
                waitFor: EWaitFor.ODOMETER,
                skippable: true,

                odometer: { tween: true }
            },
            [EWinPresentationStates.WIN_PRESENTATION_OUT_STATE]: {
                waitFor: EWaitFor.ANIMATION,
                skippable: true
            }
        },
        [EWinType.HUGE_WIN]: {
            [EWinPresentationStates.WIN_PRESENTATION_IN_STATE]: {
                waitFor: EWaitFor.ANIMATION,
                skippable: true,

                odometer: { font: true },
                particleEmitter: { start: true }
            },
            [EWinPresentationStates.WIN_PRESENTATION_IDLE_STATE]: {
                waitFor: EWaitFor.ODOMETER,
                skippable: true,

                odometer: { tween: true }
            },
            [EWinPresentationStates.WIN_PRESENTATION_OUT_STATE]: {
                waitFor: EWaitFor.ANIMATION,
                skippable: true
            }
        },
        [EWinType.MEGA_WIN]: {
            [EWinPresentationStates.WIN_PRESENTATION_IN_STATE]: {
                waitFor: EWaitFor.ANIMATION,
                skippable: true,

                odometer: { font: true },
                particleEmitter: { start: true }
            },
            [EWinPresentationStates.WIN_PRESENTATION_IDLE_STATE]: {
                waitFor: EWaitFor.ODOMETER,
                skippable: true,

                odometer: { tween: true }
            },
            [EWinPresentationStates.WIN_PRESENTATION_OUT_STATE]: {
                waitFor: EWaitFor.ANIMATION,
                skippable: true
            }
        },
        [EWinType.JACKPOT_WIN_1]: {
            [EWinPresentationStates.WIN_PRESENTATION_IN_STATE]: {
                waitFor: EWaitFor.ANIMATION,
                skippable: true,

                odometer: { font: true },
                particleEmitter: { start: true }
            },
            [EWinPresentationStates.WIN_PRESENTATION_IDLE_STATE]: {
                waitFor: EWaitFor.ODOMETER,
                skippable: true,

                odometer: { tween: true }
            },
            [EWinPresentationStates.WIN_PRESENTATION_OUT_STATE]: {
                waitFor: EWaitFor.ANIMATION,
                skippable: true
            }
        },
        [EWinType.JACKPOT_WIN_2]: {
            [EWinPresentationStates.WIN_PRESENTATION_IN_STATE]: {
                waitFor: EWaitFor.ANIMATION,
                skippable: true,

                odometer: { font: true },
                particleEmitter: { start: true }
            },
            [EWinPresentationStates.WIN_PRESENTATION_IDLE_STATE]: {
                waitFor: EWaitFor.ODOMETER,
                skippable: true,

                odometer: { tween: true }
            },
            [EWinPresentationStates.WIN_PRESENTATION_OUT_STATE]: {
                waitFor: EWaitFor.ANIMATION,
                skippable: true
            }
        },
        [EWinType.JACKPOT_WIN_3]: {
            [EWinPresentationStates.WIN_PRESENTATION_IN_STATE]: {
                waitFor: EWaitFor.ANIMATION,
                skippable: true,

                odometer: { font: true },
                particleEmitter: { start: true }
            },
            [EWinPresentationStates.WIN_PRESENTATION_IDLE_STATE]: {
                waitFor: EWaitFor.ODOMETER,
                skippable: true,

                odometer: { tween: true }
            },
            [EWinPresentationStates.WIN_PRESENTATION_OUT_STATE]: {
                waitFor: EWaitFor.ANIMATION,
                skippable: true
            }
        },
        [EWinType.JACKPOT_WIN_4]: {
            [EWinPresentationStates.WIN_PRESENTATION_IN_STATE]: {
                waitFor: EWaitFor.ANIMATION,
                skippable: true,

                odometer: { font: true },
                particleEmitter: { start: true }
            },
            [EWinPresentationStates.WIN_PRESENTATION_IDLE_STATE]: {
                waitFor: EWaitFor.ODOMETER,
                skippable: true,

                odometer: { tween: true }
            },
            [EWinPresentationStates.WIN_PRESENTATION_OUT_STATE]: {
                waitFor: EWaitFor.ANIMATION,
                skippable: true
            }
        },
        [EWinType.JACKPOT_WIN_5]: {
            [EWinPresentationStates.WIN_PRESENTATION_IN_STATE]: {
                waitFor: EWaitFor.ANIMATION,
                skippable: true,

                odometer: { font: true },
                particleEmitter: { start: true }
            },
            [EWinPresentationStates.WIN_PRESENTATION_IDLE_STATE]: {
                waitFor: EWaitFor.ODOMETER,
                skippable: true,

                odometer: { tween: true }
            },
            [EWinPresentationStates.WIN_PRESENTATION_OUT_STATE]: {
                waitFor: EWaitFor.ANIMATION,
                skippable: true
            }
        }
    }
};

export const STATIC_JACKPOT_STEPS_CONFIG: IWinPresentationStepsConfig = {
    [EWinPresentationStates.WIN_PRESENTATION_HIDDEN_STATE]: {
        waitFor: EWaitFor.WIN_PRESENTATION_START,
        skippable: false
    },
    [EWinPresentationStates.PRE_WIN_PRESENTATION_STATE]: {
        waitFor: EWaitFor.NONE,
        skippable: false
    },
    [EWinPresentationStates.WIN_PRESENTATION_HOLD_STATE]: {
        waitFor: EWaitFor.TIMER,
        skippable: true,

        stopSkipping: true,
        timer: true,
        particleEmitter: { stop: true }
    },
    [EWinPresentationStates.POST_WIN_PRESENTATION_STATE]: {
        waitFor: EWaitFor.NONE,
        skippable: false,
        stopSkipping: true
    },
    sublevels: {
        [EWinType.JACKPOT_WIN]: {
            [EWinPresentationStates.WIN_PRESENTATION_IN_STATE]: {
                waitFor: EWaitFor.ANIMATION,
                skippable: true,

                odometer: { tween: true, font: true },
                particleEmitter: { start: true }
            },
            [EWinPresentationStates.WIN_PRESENTATION_IDLE_STATE]: {
                waitFor: EWaitFor.ODOMETER,
                skippable: true
            },
            [EWinPresentationStates.WIN_PRESENTATION_OUT_STATE]: {
                waitFor: EWaitFor.ANIMATION,
                skippable: true
            }
        },
        [EJackpotType.MINI_JACKPOT]: {
            [EWinPresentationStates.WIN_PRESENTATION_IN_STATE]: {
                waitFor: EWaitFor.ANIMATION,
                skippable: true,

                odometer: { tween: true, font: true },
                particleEmitter: { start: true }
            },
            [EWinPresentationStates.WIN_PRESENTATION_IDLE_STATE]: {
                waitFor: EWaitFor.ODOMETER,
                skippable: true
            },
            [EWinPresentationStates.WIN_PRESENTATION_OUT_STATE]: {
                waitFor: EWaitFor.ANIMATION,
                skippable: true
            }
        },
        [EJackpotType.MINOR_JACKPOT]: {
            [EWinPresentationStates.WIN_PRESENTATION_IN_STATE]: {
                waitFor: EWaitFor.ANIMATION,
                skippable: true,

                odometer: { tween: true, font: true },
                particleEmitter: { start: true }
            },
            [EWinPresentationStates.WIN_PRESENTATION_IDLE_STATE]: {
                waitFor: EWaitFor.ODOMETER,
                skippable: true
            },
            [EWinPresentationStates.WIN_PRESENTATION_OUT_STATE]: {
                waitFor: EWaitFor.ANIMATION,
                skippable: true
            }
        },
        [EJackpotType.MAJOR_JACKPOT]: {
            [EWinPresentationStates.WIN_PRESENTATION_IN_STATE]: {
                waitFor: EWaitFor.ANIMATION,
                skippable: true,

                odometer: { tween: true, font: true },
                particleEmitter: { start: true }
            },
            [EWinPresentationStates.WIN_PRESENTATION_IDLE_STATE]: {
                waitFor: EWaitFor.ODOMETER,
                skippable: true
            },
            [EWinPresentationStates.WIN_PRESENTATION_OUT_STATE]: {
                waitFor: EWaitFor.ANIMATION,
                skippable: true
            }
        },
        [EJackpotType.GRAND_JACKPOT]: {
            [EWinPresentationStates.WIN_PRESENTATION_IN_STATE]: {
                waitFor: EWaitFor.ANIMATION,
                skippable: true,

                odometer: { tween: true, font: true },
                particleEmitter: { start: true }
            },
            [EWinPresentationStates.WIN_PRESENTATION_IDLE_STATE]: {
                waitFor: EWaitFor.ODOMETER,
                skippable: true
            },
            [EWinPresentationStates.WIN_PRESENTATION_OUT_STATE]: {
                waitFor: EWaitFor.ANIMATION,
                skippable: true
            }
        }
    }
};
